import { create } from 'zustand';

import type { LocalizationStore } from './localization.store.types';

import { dictionary } from 'shared/legacy/contexts/LocalizationContext/languages/nl';

export const useLocalizationStore = create<LocalizationStore>((set) => ({
  dictionary: dictionary,
  setDictionary: (dictionary) => set(() => ({ dictionary })),
}));
